import * as React from 'react';

import FileExcel16 from './FileExcel16';

export const fileExcel16 = () => <FileExcel16 />;

export default {
    title: 'Icon/Fill/FileExcel16',
    component: FileExcel16,
    parameters: {
        notes: "`import FileExcel16 from 'box-ui-elements/es/icon/fill/FileExcel16';`",
    },
};
